export default function TranslatesRun(
    $translates
) {
    'ngInject';
    $translates.__init__();
}


/** WEBPACK FOOTER **
 ** ./frontend/bootstrap/translates.run.js
 **/